export default function NoPermission() {
    return <>You do not have permission to this page. Please change Store or contact your Store owner.</>
}